// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobsTable th {
    border-bottom: 1px solid black;
    text-align: left;
}

.JobsTable tr {
    height: 40px;
}

.placeHolder {
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Unterlaeufe abgesetzt, damit die Zuordnung auf einen Blick erkennbar ist. Nur ein Hauch
   Hintergrund -- die Einrueckung traegt die Aussage, die Farbe unterstuetzt sie. */
.childRow {
    background-color: rgba(128, 128, 128, 0.07);
}

/* Die Einrueckungsmarke wird gezeichnet, nicht als Symbol geladen: Symbolnamen kommen zur
   Laufzeit aus einer Medienquelle, ein dort fehlender Name zeichnet stillschweigend nichts. */
.childArrow::before {
    content: "";
    width: 12px;
    height: 12px;
    margin-left: 14px;
    border-left: 1px solid currentColor;
    border-bottom: 1px solid currentColor;
    opacity: 0.35;
}

.jobName {
    font-weight: 500;
}

/* Die Lauf-ID steht klein unter dem Namen: Man braucht sie gelegentlich zum Nachsehen im
   Protokoll, aber sie darf den Namen nicht verdecken -- vorher stand an dieser Stelle
   ausschliesslich die ID. */
.jobRunID {
    font-size: 10px;
    opacity: 0.45;
    font-family: monospace;
    -webkit-user-select: all;
            user-select: all;
}

/* Die Kennzahl steht rechts in der Kopfzeile, abgesetzt vom Schalter links. */
.queueHeader {
    align-items: center;
    gap: 16px;
}

.serviceCounts {
    margin-left: auto;
    display: flex;
    gap: 12px;
    font-size: 12px;
    opacity: 0.8;
}

/* Der Umschalter sitzt neben der Benutzer-Auswahl, die Kennzahl bleibt rechts (margin-left:
   auto an .serviceCounts). Klein gehalten, damit die Kopfzeile nicht hoeher wird als die
   Checkbox daneben. */
.runFilter {
    font-size: 12px;
}

.runFilter .mat-button-toggle-label-content {
    line-height: 30px;
    padding: 0 10px;
}

/* Woher ein Lauf kommt. Dezent, weil die Spalte bei Worker-Laeufen -- dem Normalfall --
   nur bestaetigt, was man erwartet. Ein Dienst-Lauf ist der erklaerungsbeduerftige Fall
   und wird deshalb hervorgehoben: Er laeuft im Dienstprozess und ist nicht abbrechbar. */
.runsIn {
    font-size: 11px;
    opacity: 0.6;
    white-space: nowrap;
}

.runsIn.runsInService {
    opacity: 1;
    font-weight: 600;
}

/* Der Weg ins Protokoll bei Grafana. Als Text und nicht als Symbol: Die Symbolsammlung wird
   zur Laufzeit aus der Medienquelle geladen, ein fehlender Name faellt lautlos aus. */
.logLink {
    font-size: 11px;
    text-decoration: underline;
    cursor: pointer;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/jobs/queue/jobs.queue.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;mFACmF;AACnF;IACI,2CAA2C;AAC/C;;AAEA;8FAC8F;AAC9F;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mCAAmC;IACnC,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;4BAE4B;AAC5B;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,wBAAgB;YAAhB,gBAAgB;AACpB;;AAEA,8EAA8E;AAC9E;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;;sBAEsB;AACtB;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;yFAEyF;AACzF;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;sFACsF;AACtF;IACI,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB","sourcesContent":[".JobsTable th {\n    border-bottom: 1px solid black;\n    text-align: left;\n}\n\n.JobsTable tr {\n    height: 40px;\n}\n\n.placeHolder {\n    width: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Unterlaeufe abgesetzt, damit die Zuordnung auf einen Blick erkennbar ist. Nur ein Hauch\n   Hintergrund -- die Einrueckung traegt die Aussage, die Farbe unterstuetzt sie. */\n.childRow {\n    background-color: rgba(128, 128, 128, 0.07);\n}\n\n/* Die Einrueckungsmarke wird gezeichnet, nicht als Symbol geladen: Symbolnamen kommen zur\n   Laufzeit aus einer Medienquelle, ein dort fehlender Name zeichnet stillschweigend nichts. */\n.childArrow::before {\n    content: \"\";\n    width: 12px;\n    height: 12px;\n    margin-left: 14px;\n    border-left: 1px solid currentColor;\n    border-bottom: 1px solid currentColor;\n    opacity: 0.35;\n}\n\n.jobName {\n    font-weight: 500;\n}\n\n/* Die Lauf-ID steht klein unter dem Namen: Man braucht sie gelegentlich zum Nachsehen im\n   Protokoll, aber sie darf den Namen nicht verdecken -- vorher stand an dieser Stelle\n   ausschliesslich die ID. */\n.jobRunID {\n    font-size: 10px;\n    opacity: 0.45;\n    font-family: monospace;\n    user-select: all;\n}\n\n/* Die Kennzahl steht rechts in der Kopfzeile, abgesetzt vom Schalter links. */\n.queueHeader {\n    align-items: center;\n    gap: 16px;\n}\n\n.serviceCounts {\n    margin-left: auto;\n    display: flex;\n    gap: 12px;\n    font-size: 12px;\n    opacity: 0.8;\n}\n\n/* Der Umschalter sitzt neben der Benutzer-Auswahl, die Kennzahl bleibt rechts (margin-left:\n   auto an .serviceCounts). Klein gehalten, damit die Kopfzeile nicht hoeher wird als die\n   Checkbox daneben. */\n.runFilter {\n    font-size: 12px;\n}\n\n.runFilter .mat-button-toggle-label-content {\n    line-height: 30px;\n    padding: 0 10px;\n}\n\n/* Woher ein Lauf kommt. Dezent, weil die Spalte bei Worker-Laeufen -- dem Normalfall --\n   nur bestaetigt, was man erwartet. Ein Dienst-Lauf ist der erklaerungsbeduerftige Fall\n   und wird deshalb hervorgehoben: Er laeuft im Dienstprozess und ist nicht abbrechbar. */\n.runsIn {\n    font-size: 11px;\n    opacity: 0.6;\n    white-space: nowrap;\n}\n\n.runsIn.runsInService {\n    opacity: 1;\n    font-weight: 600;\n}\n\n/* Der Weg ins Protokoll bei Grafana. Als Text und nicht als Symbol: Die Symbolsammlung wird\n   zur Laufzeit aus der Medienquelle geladen, ein fehlender Name faellt lautlos aus. */\n.logLink {\n    font-size: 11px;\n    text-decoration: underline;\n    cursor: pointer;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
